import { Type } from "@sinclair/typebox";
import { quoteCompositionSchema, quoteLineCompositionProperties } from "./quote-composition.js";
import { quoteContractOptionsInputSchema } from "./quote-contract-options.js";
import { quoteWorkingPortionInputSchema, quoteWorkingPortionSnapshotSchema } from "./quote-working-portion.js";
const text = Type.String({ maxLength: 12000 });
const id = Type.String({ minLength: 1, maxLength: 120 });
// Draft values deliberately remain text: incomplete input is not an economic snapshot.
export const quoteEditingDraftSchema = Type.Object({
    baseQuoteVersionId: Type.Optional(id),
    baseCampaignRevision: Type.Optional(Type.Integer({ minimum: 1 })),
    lines: Type.Array(Type.Object({
        ...quoteLineCompositionProperties,
        id,
        lineKey: id,
        description: text,
        unit: text,
        quantity: text,
        suggestedUnitPrice: Type.Union([Type.Null(), text]),
        finalUnitPrice: text,
        catalogItemId: Type.Optional(id),
        publicReferenceItemId: Type.Optional(id),
        workItemId: Type.Optional(Type.Union([Type.Null(), id])),
        pricingCriterion: Type.Optional(text),
        overrideReason: Type.Optional(text),
        publicReference: Type.Optional(Type.Object({ code: text, price: text }))
    }), { maxItems: 200 }),
    conditions: Type.String({ maxLength: 5000 }),
    composition: Type.Optional(quoteCompositionSchema),
    contractOptions: Type.Optional(Type.Unsafe({
        ...quoteContractOptionsInputSchema,
        properties: {
            preset: Type.Union([
                Type.Literal("standard"),
                Type.Literal("maintenance"),
                Type.Literal("maintenance_lifeline")
            ]),
            annualFee: Type.Optional(text),
            lifelineAnnualFee: Type.Optional(text)
        }
    })),
    scope: Type.Optional(Type.Object({
        memberIds: Type.Array(id, { maxItems: 5 }),
        partiesConfirmed: Type.Boolean(),
        partyFingerprint: text,
        workingPortions: Type.Optional(Type.Record(Type.String(), quoteWorkingPortionInputSchema)),
        portionSnapshots: Type.Optional(Type.Record(Type.String(), quoteWorkingPortionSnapshotSchema))
    }))
}, { additionalProperties: false });
export const quoteEditingDraftRecordSchema = Type.Object({
    revision: Type.Integer({ minimum: 0 }),
    draft: Type.Union([quoteEditingDraftSchema, Type.Null()])
});
//# sourceMappingURL=quote-editing-draft.js.map